










































import { Component, Watch, Vue } from "vue-property-decorator";

import PageTitle from "@/components/common/PageTitle.vue";
import Pagination from "@/components/common/Pagination.vue";
import { IPageMeta } from "@/services/interfaces";

import { HowUseCatalog } from "./blocks/HowUseCatalog";
import { ProductsList } from "./blocks/ProductsList";
import SubMenu from "./blocks/ProductsList/blocks/SubMenu.vue";
import {
  catalogModule,
  commonModule,
  personalModule,
} from "@/plugins/store-accessors";
import { qSet } from "@/services/utils";

@Component({
  name: "catalog-page",
  components: { ProductsList, PageTitle, HowUseCatalog, Pagination, SubMenu },
})
export default class CatalogPage extends Vue {
  get getOnBoarding() {
    return commonModule.getOnBoarding;
  }

  get isAuthorized() {
    return personalModule.isAuthorized;
  }

  get metaData() {
    return catalogModule.getMeta;
  }

  get fetching() {
    return catalogModule.getFetching;
  }

  get query() {
    return this.$route.query?.q || "";
  }

  get error() {
    return catalogModule.getError;
  }

  get subcategories() {
    return this.metaData.subcategories;
  }

  @Watch("isAuthorized")
  @Watch("$route")
  async catalog() {
    await catalogModule.getCatalog({
      ...this.$route.params,
      query: this.$route.query,
      route: this.$route.name,
    });

    window?.scrollTo({ top: 0, behavior: "smooth" });
  }

  @Watch("metaData")
  setMeta(meta: IPageMeta) {
    if (meta.title) document.title = meta.title;
  }

  interactive() {
    commonModule.SET_ONBOARDING(true);
  }

  checkOnBoarding() {
    const complete = localStorage.getItem("onBoarding");
    if (!complete) {
      this.interactive();
    }
  }

  paginator(page: number) {
    if (page === 1) {
      this.querySetter("page", null);
      return;
    }
    this.querySetter("page", page);
  }

  querySetter(name: string, value: string | number | null) {
    const { query, path } = this.$route;
    const q = qSet(name, value, query);
    this.$router.push({ path, query: q });
  }

  mounted() {
    this.catalog();
    this.setMeta(this.metaData);
    this.checkOnBoarding();
  }
  beforeDestroy() {
    catalogModule.resetStore();
  }
}
